import React, { useState } from 'react';
import { AFFILIATE_ENABLED } from './featureFlags';
import './AffiliateOffer.css';

const DISMISS_KEY = 'vetbill_dismissed_offers';

const getDismissed = () => {
  try {
    const raw = localStorage.getItem(DISMISS_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

const rememberDismissed = (id) => {
  try {
    const next = Array.from(new Set([...getDismissed(), id]));
    localStorage.setItem(DISMISS_KEY, JSON.stringify(next));
  } catch {
    /* ignore storage failures */
  }
};

// Force-render for a live preview without enabling affiliates for everyone:
// run `localStorage.setItem('vetbill_affiliate_preview','1')` in the console.
const isPreview = () => {
  try {
    return localStorage.getItem('vetbill_affiliate_preview') === '1';
  } catch {
    return false;
  }
};

// A quiet, clearly-labeled sponsored card. Renders nothing unless affiliates are
// enabled (or preview is on), an offer is passed, and the user hasn't dismissed
// that offer before.
const AffiliateOffer = ({ offer }) => {
  const [dismissed, setDismissed] = useState(() => (offer ? getDismissed().includes(offer.id) : true));

  if ((!AFFILIATE_ENABLED && !isPreview()) || !offer || dismissed) {
    return null;
  }

  const handleDismiss = () => {
    rememberDismissed(offer.id);
    setDismissed(true);
  };

  return (
    <aside className="affiliate-offer" aria-label="Sponsored suggestion">
      <div className="affiliate-offer-tag">Sponsored</div>
      <button type="button" className="affiliate-offer-dismiss" onClick={handleDismiss} aria-label="Hide this suggestion">✕</button>
      <div className="affiliate-offer-body">
        <span className="affiliate-offer-icon" aria-hidden="true">{offer.icon}</span>
        <div>
          <strong>{offer.headline}</strong>
          <p>{offer.body}</p>
          <a
            className="affiliate-offer-cta"
            href={offer.url}
            target="_blank"
            rel="sponsored noopener noreferrer"
          >
            {offer.cta} →
          </a>
        </div>
      </div>
      <p className="affiliate-offer-disclosure">
        Sponsored. VetBill may earn a commission if you sign up — it never changes the prices we show.
      </p>
    </aside>
  );
};

export default AffiliateOffer;
